
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import DropdownMenu from '@/common/dropdown-menu/DropdownMenu.vue';
import Icon, { Icon as IconName } from '@/common/icon/Icon.vue';
import { SortOption, ORIENTATION_OPTIONS } from './sorting';

export default Vue.extend({
    name: 'QnaSortingPicker',

    components: {
        DropdownMenu,
        Icon
    },

    props: {
        options: {
            type: Array as PropType<SortOption[]>,
            required: true
        },

        selectedOption: {
            type: Object as PropType<SortOption>,
            default: () => ({} as SortOption)
        },

        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },

        selectedOrientation: {
            type: String,
            default: () => null
        }
    },

    data() {
        return {
            orientation: this.selectedOption?.defaultOrientation,
            upDownIcon: IconName.upDown
        };
    },

    computed: {
        showOrientationToggler(): boolean {
            return this.selectedOption?.showOrientationToggler;
        },

        orientationLabel(): string | null {
            if (!this.showOrientationToggler) {
                return null;
            }
            const orientationLabels = get(this, 'labels.orientationOptions', {});
            return orientationLabels?.[this.selectedOption.id]?.[this.orientation];
        }
    },

    methods: {
        onSelect(sortOptionId: string) {
            const option = this.options.find(option => option.id === sortOptionId);
            if (!option) return;

            if (option.showOrientationToggler) {
                this.setOrientation(option.defaultOrientation);
            }
            this.$emit('select', sortOptionId);
        },
        toggleOrientation() {
            const newOrientation = this.orientation === ORIENTATION_OPTIONS.BOTTOM_TO_TOP ?
                ORIENTATION_OPTIONS.TOP_TO_BOTTOM :
                ORIENTATION_OPTIONS.BOTTOM_TO_TOP;
            this.setOrientation(newOrientation);
        },
        setOrientation(orientation: string) {
            this.orientation = orientation;
            this.$emit('update:selected-orientation', this.orientation);
        }
    }
});
